import React from "react";
import PropTypes from "prop-types";
import HeaderTitle from "header/components/title";

const VerifyPhoneHeader = ({ mobileValidated }) => {
  let title = "Verifying your phone...";
  if (mobileValidated === true) {
    title = "Success!";
  } else if (mobileValidated === false) {
    title = "Whoops!";
  }
  return <HeaderTitle title={title} />;
};

export default VerifyPhoneHeader;
